import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { breadcrumbJsonLd, organizationJsonLd, softwareApplicationJsonLd } from "../content/structuredData";
import { PAGE_SEO } from "../content/pageMeta";
import {
  langFromPath,
  pagePath,
  type MarketingLang,
  type MarketingPageId,
} from "../content/routes";
import { usePageMeta } from "../../features/help/usePageMeta";

export function useMarketingLang(): MarketingLang {
  const { pathname } = useLocation();
  return langFromPath(pathname);
}

export function useMarketingPage(pageId: MarketingPageId) {
  const lang = useMarketingLang();
  const seo = PAGE_SEO[pageId][lang];
  const canonicalPath = pagePath(pageId, lang);
  const jsonLd = useMemo(() => {
    const origin = typeof window === "undefined" ? "" : window.location.origin;
    if (pageId === "home") {
      return [organizationJsonLd(origin), softwareApplicationJsonLd(origin, lang)];
    }
    return [
      breadcrumbJsonLd(origin, lang, [
        { id: "home", name: "OwnerFlow" },
        { id: pageId, name: seo.h1 },
      ]),
    ];
  }, [lang, pageId, seo.h1]);

  usePageMeta({
    title: seo.title,
    description: seo.description,
    canonicalPath,
    ogType: "website",
    language: lang,
    jsonLd,
  });

  return { lang, seo, canonicalPath };
}
